import {Grid, Typography, UnstableCard as Paper} from '@yandex-delivery/blocks'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import type {ReactElement, ReactNode} from 'react'

import {Body, Header, Skeleton, Tabs} from 'src/shared/components/desktop'
import {i18n} from 'src/shared/config'

import iconSrc from './assets/Delivery.svg'
import {CargoRequirements} from './CargoRequirements/CargoRequirements'
import {CourierInfo} from './CourierInfo/CourierInfo'
import {DeliveryDirectionVerticals} from './DeliveryDirectionVerticals/DeliveryDirectionVerticals'
import {useVerticals} from './hooks'
import type {Props} from './types'
import * as classes from './Verticals.classes'

export function Verticals({children, showAdditions = true}: Props): ReactElement {
  const {preparedVerticalGroups, verticalName, isVerticalsPending, handleVerticalDirectionSelect} = useVerticals()

  let additionalElement: ReactNode = null

  if (showAdditions) {
    if (verticalName === 'cargo') {
      additionalElement = (
        <Grid xs={12} item>
          {isVerticalsPending ? <Body tail={<Skeleton height={17} />} /> : <CargoRequirements />}
        </Grid>
      )
    }

    if (verticalName === 'walking_courier') {
      additionalElement = (
        <Grid xs={12} item>
          {isVerticalsPending ? <Body tail={<Skeleton height={17} />} /> : <CourierInfo />}
        </Grid>
      )
    }
  }

  return (
    <Paper className={showAdditions ? undefined : classes.additionalPaper} radius="L">
      <Grid size="m" container>
        <Grid xs={12} item>
          <Header
            lead={<img alt="" height={spacing(4.5)} loading="lazy" src={iconSrc} width={spacing(4.25)} />}
            tail={children}
          >
            <Typography group="tight" thickness="medium" variant="title4">
              {i18n('cargo.create.form.order', 'Заказать')}
            </Typography>
          </Header>
        </Grid>
        {preparedVerticalGroups.length > 1 && (
          <Grid xs={12} item>
            <Body
              tail={
                isVerticalsPending ? (
                  <Skeleton height={6} />
                ) : (
                  <Tabs
                    data-e2e="tabs-city-or-country"
                    items={preparedVerticalGroups}
                    name="offerFlow.deliveryDirection"
                    onChange={handleVerticalDirectionSelect}
                  />
                )
              }
            />
          </Grid>
        )}
        <Grid xs={12} item>
          <Body tail={<DeliveryDirectionVerticals />} />
        </Grid>
        {additionalElement}
      </Grid>
    </Paper>
  )
}
